import React, { useRef, useState } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { Space, Modal, Row, Col, Image } from "antd";
import { Button } from "@mui/material";
import moment from 'moment';
import CloseIcon from "../../../../assets/images/icon_menus/Close Button.svg";
import html2pdf from "html2pdf.js";
import colorborder from "../../../../assets/images/colorborder.png";
import { isOnline, getReportSnapshotAt } from "../../../../helpers/axiosClient";


const ReportModal = React.forwardRef((props, ref) => {
    const { title, handleClose, open, businessDetails, list, reportType } = props;
    const pdfExportComponent = useRef(null);
    const [loading, setLoading] = useState(false);
    // When offline, the report is a snapshot of the last online download (server
    // aggregations can't be recomputed without a connection) — stamp it so the
    // viewer/PDF shows it is not live. getReportSnapshotAt() is set by the data
    // layer on each offline report replay (src/data/repository.js).
    const offlineSnapshotAt = !isOnline() ? getReportSnapshotAt() : null;

    // const handleDownload = (type = 'download') => {
    //     const content = pdfExportComponent.current;
    //     const doc = new jsPDF('pt', 'px', 'a4');
    //     doc.addFileToVFS('Roboto-Regular.ttf', NormalFont);
    //     doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
    //     doc.addFileToVFS('Roboto-Medium.ttf', MediumFont);
    //     doc.addFont('Roboto-Medium.ttf', 'RobotoMedium', 'normal');
    //     doc.setFont("Roboto");
    //     doc.setFont("RobotoMedium");
    //     doc.html(content, {
    //         callback: function (doc) {
    //             if (type === 'print') {
    //                 doc.autoPrint();
    //                 window.open(doc.output('bloburl'));
    //             } else {
    //                 doc.save(`${title}`);
    //             }
    //         },
    //         margin: 10,
    //         autoPaging: "text",
    //         html2canvas: { scale: 0.406 } // change the scale to whatever number you need
    //     });
    // };

    const handleDownloadNew = (type = 'download') => {
        const element = pdfExportComponent.current;
        let iv = '';
        setLoading(true);
        html2pdf().from(element).set({
            margin: [10, 5, 10, 5], // [top, left, bottom, right]
            filename: `${title}`,
            autoPaging: 'text',
            image: { type: "jpeg", quality: 1.0 },
            html2canvas: {
                scale: 3, // Increase scale for high resolution
                dpi: 300, // Ensure high DPI
                useCORS: true,
                letterRendering: true,
            }, // A4 width in pixels (≈ 210mm)
            pagebreak: { mode: ["css", "legacy"], before: '.page-break', avoid: '.no-break' },
            jsPDF: { unit: "mm", format: "a3", orientation: reportType === 'landscape' ? 'landscape' : "portrait" },
        }).toPdf().get("pdf").then((pdf) => {
            // pdf.setFont("Roboto");
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);

                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
                pdf.addImage(colorborder, "PNG", 5, 10, pageWidth - 10, pageHeight - 20); // x, y, width, height

                pdf.setFontSize(10);
                pdf.setTextColor(49, 119, 135);
                // if (title === 'Product Group wise Analysis') {
                //     pdf.text(`${iv} Pg. ${i} | ${totalPages}`, 395, 293);
                // } else {
                //     pdf.text(`${iv} Pg. ${i} | ${totalPages}`, 276, 415); // Bottom center
                // }
                // pdf.setFontSize(10);
                // pdf.setTextColor(49, 119, 135);
                // if (title === 'Product Group wise Analysis') {
                //     pdf.text('* Powered by YOUNOTE', 5, 293);
                // } else {
                //     pdf.text('* Powered by YOUNOTE', 5, 415);
                // }

                const rightTextWidth = pdf.getTextWidth(`${iv} Pg. ${i} | ${totalPages}`);
                pdf.text(`${iv} Pg. ${i} | ${totalPages}`, pageWidth - rightTextWidth - 5, pageHeight - 5);
                pdf.text('* Powered by YOUNOTE', 5, pageHeight - 5);
            }

            if (type === 'print') {
                pdf.autoPrint();
                const blob = pdf.output("blob");
                const formData = new FormData();
                formData.append("mode", "file");        // tell server you're sending PDF
                formData.append("file", blob, "file.pdf");
                fetch(process.env.REACT_APP_EXE_CONNECT_URL, {
                    method: "POST",
                    body: formData
                }).then(res => res.json()).then(data => { })
                    .catch(err => {
                        window.open(pdf.output('bloburl', "_blank"));
                        console.error(err);
                    });
                //window.open(pdf.output('bloburl', "_blank"));
            } else {
                pdf.save(`${title}`);
            }
            setLoading(false);
        });
    }

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }


    const classes = customStyles();
    return (
        <Modal title="" open={open} footer={null}
            onCancel={() => handleClose(!open)}
            width={title === 'Product Group wise Analysis' || title === 'Resale Value Report' ? 1500 : 1100}
            closable={false}
            className={clsx(classes.invoiceDesign, classes.removeUnderline)}>
            <Row gutter={75} className={classes.invoiceHeader}>
                <Col span={24} className={clsx(classes.textAlignRight, classes.fontSize0)}>
                    <Space size={[20, 20]} direction="horizontal" align="center">
                        <Button
                            key="confirm"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownloadNew('print')}
                            className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}
                        >Print</Button>
                        <Button
                            key="save"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownloadNew()}
                            className={clsx(classes.modalBtn, { [classes.loading]: loading })}
                        >Download</Button>
                        <Image onClick={() => handleClose(!open)} src={CloseIcon} preview={false} className={classes.cursor} />
                    </Space>
                </Col>
            </Row>
            <div ref={pdfExportComponent} className={clsx(classes.divToPrint, classes.divToPrintReport)}>
                <div className={classes.downloadbars}>
                    <div className={classes.downloadtopbar}></div>
                    <div className={classes.downloadsecondbar} style={{ height: 40 }}></div>
                </div>
                <div className={clsx(classes.downloaddetails)}>
                    <Row>
                        <Col span={12} className={clsx(classes.bill, classes.thirdSection)}>
                            <h2 style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={classes.aTitle}>{businessDetails?.businessName}</h2>
                            <p className={clsx(classes.textFieldColor, classes.fonSize14)}>{address(businessDetails)}</p>
                            <p className={clsx(classes.textFieldColor, classes.fonSize14)}>{address1(businessDetails)}</p>
                        </Col>
                        <Col span={12} className={clsx(classes.textAlignRight, classes.thirdSection)}>
                            <p style={{ padding: 0 }} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Date</p>
                            <p className={clsx(classes.textFieldColor, classes.fonSize14)}>{moment().format('DD MMM YYYY')}</p>
                            {offlineSnapshotAt ? (
                                <p style={{ padding: 0, color: '#b8860b' }} className={clsx(classes.fonSize13)}>
                                    Offline snapshot — as of {moment(offlineSnapshotAt).format('DD MMM YYYY, hh:mm A')}
                                </p>
                            ) : null}
                        </Col>
                    </Row>
                    <div className={clsx(classes.thirdSectionReport, classes.thirdSection, classes.blackBorderTop)}>
                        {list}
                    </div>
                </div>
            </div>
        </Modal>
    )
});

export default ReportModal;